import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom"; 
import axios from "axios";
import APIURL from "../../common/Config";
import "../header/header.css";
import defaultProfileImg from "../../assets/blankprofile.webp";
import AuthModal from "../signup/AuthModal";
import { useDispatch } from "react-redux"; // Hook ko import karo
import { openAuthModal } from "../../redux/authSlice";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [profileImg, setProfileImg] = useState(defaultProfileImg);
  const [userData, setUserData] = useState(null);
const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const profileDropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const sidebarProfileRef = useRef(null);

  const location = useLocation(); 

//   const [showAuthModal, setShowAuthModal] = useState(false);
// const [authMode, setAuthMode] = useState("login");

// const openAuth = (mode) => {
//   setAuthMode(mode);
//   setShowAuthModal(true);
//   setMenuOpen(false);
// };
const openAuth = (mode) => {
  dispatch(openAuthModal(mode)); // Redux trigger: Modal khul jayega
  setMenuOpen(false); // Sidebar band ho jayega
};
  useEffect(() => {
    const fetchUserData = async () => {
      const phoneNumber = localStorage.getItem("phoneNumber");
      const isLoggedInStored = localStorage.getItem("isLoggedIn");

      if (isLoggedInStored === "true" && phoneNumber) {
        try {
          const response = await axios.get(
            `${APIURL}/astroservice/login/ascustomer/${phoneNumber}`
          );
          const user = response.data;

          setIsLoggedIn(true);
          setUserData(user);

          setProfileImg(
            user.photoUrlpath && user.photoUrlpath.trim() !== ""
              ? user.photoUrlpath
              : defaultProfileImg
          );

          localStorage.setItem("userData", JSON.stringify(user));
        } catch (error) {
          console.error("Failed to fetch user profile:", error);
        }
      }
    };

    fetchUserData();

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(event.target)
      ) {
        setProfileMenuOpen(false);
      }
      if (
        sidebarProfileRef.current &&
        !sidebarProfileRef.current.contains(event.target)
      ) {
        setProfileMenuOpen(false);
      }
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        !event.target.classList.contains("hamburger") &&
        !event.target.parentElement?.classList.contains("hamburger")
      ) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  
  const getNavLinkClass = (path) => {
  
    if (path === "/horoscope-dropdown") {
      const horoscopePaths = ["/daily-horoscope", "/yearly-horoscope", "/festival"];
      return horoscopePaths.includes(location.pathname) ? "nav-item active" : "nav-item";
    }
    
    return location.pathname === path ? "nav-item active" : "nav-item";
  };
 

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleDropdown = (e) => {
    e.stopPropagation();
    setDropdownOpen(!dropdownOpen);
  };
  const toggleProfileMenu = (e) => {
    e.stopPropagation();
    setProfileMenuOpen(!profileMenuOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("userData");
    localStorage.removeItem("userType");
    localStorage.removeItem("customerData");
    localStorage.removeItem("astrologerData");
    localStorage.removeItem("phoneNumber");
    localStorage.clear()
    setIsLoggedIn(false);
    setUserData(null);
    setProfileImg(defaultProfileImg);
    setMenuOpen(false);
    window.location.href = "/";
  };

  return (
    <header className="main-header">
      <div className="header-left">
        <Link to="/">
          <img
            src={require("../../assets/AstroBhagya_LOGO.webp")}
            alt="Logo"
            className="logo"
          />
        </Link>
        <Link to="/">
          <img
            src={require("../../assets/AstrobhagyaName.webp")}
            alt="Logo Name"
            className="logo-text"
          />
        </Link>
      </div>


      {menuOpen && (
  <div className="sidebar-overlay" onClick={() => setMenuOpen(false)}>
    <div className="sidebar" ref={mobileMenuRef} onClick={(e) => e.stopPropagation()}>
      <div className="close-btns" onClick={toggleMenu}>×</div>

      {/* Profile Section (TOP) */}
      {isLoggedIn && userData && (
        <div className="sidebar-profile-section">
          <img src={profileImg} alt="Profile" className="sidebar-profile-avatar" />
          <div className="sidebar-profile-name">
            {userData?.firstName} {userData?.lastName}
          </div>
        </div>
      )}

      {/* Navigation Items (MIDDLE) */}
      <div className="sidebar-nav-items">
        <Link to="/" className={getNavLinkClass("/")} onClick={toggleMenu}>Home</Link>
        <Link to="/blogs" className={getNavLinkClass("/blogs")} onClick={toggleMenu}>Blogs</Link>
        <Link to="/festival" className={getNavLinkClass("/festival")} onClick={toggleMenu}>Festivals</Link>
        <div className="nav-item kundli-sidebar-item">
  Kundli <span className="coming-soon-badge">Coming Soon</span>
</div>
        <Link to="/daily-horoscope" className={getNavLinkClass("/daily-horoscope")} onClick={toggleMenu}>Daily Horoscope</Link>
        <Link to="/yearly-horoscope" className={getNavLinkClass("/yearly-horoscope")} onClick={toggleMenu}>Yearly Horoscope</Link>
        <Link to="/chat-with-astrologer" className={getNavLinkClass("/chat-with-astrologer")} onClick={toggleMenu}>Chat </Link>
        <Link to="/call-with-astrologer" className={getNavLinkClass("/call-with-astrologer")} onClick={toggleMenu}>Call</Link>
      </div>

      {/* Auth & Account Section (BOTTOM) */}
      <div className="sidebar-footer">
        {!isLoggedIn ? (
          <button className="unified-auth-btn mobile-login" onClick={() => openAuth('login')}>
            Login / Signup
          </button>
        ) : (
          <div className="sidebar-logged-footer">
            <Link to="/wallet" className="sidebar-footer-item" onClick={toggleMenu}>
              <span className="item-icon">💰</span> Wallet
            </Link>
            <Link to="/profile" className="sidebar-footer-item" onClick={toggleMenu}>
              <span className="item-icon">👤</span> My Profile
            </Link>
            <Link to="/my-sessions" className="sidebar-footer-item" onClick={toggleMenu}>
  <span className="item-icon">📜</span> My Sessions
</Link>
            <Link to="/my-following" className="sidebar-footer-item" onClick={toggleMenu}>
  <span className="item-icon">⭐</span> My Following
</Link>
            <Link to="/help-and-support" className="sidebar-footer-item" onClick={toggleMenu}>
  <span className="item-icon">🎧</span>Help & Support
</Link>
            <button className="sidebar-footer-item logout-btn" onClick={handleLogout}>
              <span className="item-icon">⏻</span> Logout
            </button>
          </div>
        )}
      </div>
    </div>
  </div>
)}

      {/* {menuOpen && (
        <div className="sidebar-overlay" onClick={() => setMenuOpen(false)}>
          <div
            className="sidebar"
            ref={mobileMenuRef}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="close-btns" onClick={toggleMenu}>
              ×
            </div>

            {isLoggedIn && userData && (
              <div className="sidebar-profile-section" ref={sidebarProfileRef}>
                <div className="sidebar-profile-header">
                  <img
                    src={profileImg}
                    alt="Profile"
                    className="sidebar-profile-avatar"
                    onError={(e) => (e.currentTarget.src = defaultProfileImg)}
                  />
                  <div className="sidebar-profile-name">
                    {userData?.firstName} {userData?.lastName}
                  </div>
                </div>
                <div className="sidebar-profile-menu">
                  <Link
                    to="/profile"
                    className={`sidebar-profile-item ${location.pathname === "/profile" ? "active" : ""}`}
                    onClick={toggleMenu}
                  >
                    Profile
                  </Link>
                  <div className="sidebar-profile-item" onClick={handleLogout}>
                    Logout
                  </div>
                </div>
              </div>
            )}

            <div className="sidebar-nav-items">
              <Link to="/" className={getNavLinkClass("/")} onClick={toggleMenu}>
                Home
              </Link>
              <Link to="/blogs" className={getNavLinkClass("/blogs")} onClick={toggleMenu}>
                Blogs
              </Link>
              <Link to="/festival" className={getNavLinkClass("/festival")} onClick={toggleMenu}>
                Festivals
              </Link>
              <Link to="/daily-horoscope" className={getNavLinkClass("/daily-horoscope")} onClick={toggleMenu}>
                Daily Horoscope
              </Link>
              <Link to="/yearly-horoscope" className={getNavLinkClass("/yearly-horoscope")} onClick={toggleMenu}>
                Yearly Horoscope
              </Link>
              <Link to="/chat-with-astrologer" className={getNavLinkClass("/chat-with-astrologer")} onClick={toggleMenu}>
                Chat with Astrologer
              </Link>
              <Link to="/call-with-astrologer" className={getNavLinkClass("/call-with-astrologer")} onClick={toggleMenu}>
                Call with Astrologer
              </Link>
            </div>


            {!isLoggedIn && (
  <div className="sidebar-footer">
    <button
      className="unified-auth-btn mobile-login"
      onClick={() => openAuth('login')}
    >
      Login / Signup
    </button>
  </div>
)}
          </div>
        </div>
      )} */}

      <div className="header-right">
        <div className="nav-item-wrapper" ref={dropdownRef}>
          <div
            className={`${getNavLinkClass("/horoscope-dropdown")} ${dropdownOpen ? "dropdown-open" : ""}`}
            onClick={toggleDropdown}
            style={{ cursor: "pointer" }}
          >
            Horoscope <span
    style={{
      fontSize: "10px",
      transition: "transform 0.2s ease",
      transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
      display: "inline-block",
    }}
  >
    ▼
  </span>
          </div>
          {dropdownOpen && (
            <div className="dropdown-menu">
              <Link to="/daily-horoscope" className={location.pathname === "/daily-horoscope" ? "active-dropdown-item" : ""}>Daily Horoscope</Link>
              <Link to="/yearly-horoscope" className={location.pathname === "/yearly-horoscope" ? "active-dropdown-item" : ""}>Yearly Horoscope</Link>
              <Link to="/festival" className={location.pathname === "/festival" ? "active-dropdown-item" : ""}>Festivals</Link>
            </div>
          )}
        </div>

<div className="nav-item-wrapper kundli-wrapper">
  <div className="nav-item kundli-nav">
    Kundli
    <span className="coming-soon-badge">Coming Soon</span>
  </div>
</div>

<Link to="/blogs" className={getNavLinkClass("/blogs")}>
  Blogs
</Link>
        {/* <Link to="/blogs" className={getNavLinkClass("/blogs")}>
          Blogs
        </Link> */}
        <Link to="/chat-with-astrologer" className={getNavLinkClass("/chat-with-astrologer")}>
          Chat
        </Link>
        <Link to="/call-with-astrologer" className={getNavLinkClass("/call-with-astrologer")}>
          Call
        </Link>

        {isLoggedIn && userData ? (
          <div className="profile-dropdown-wrapper" ref={profileDropdownRef}>
            <img
              src={profileImg}
              alt="Profile"
              className="profile-avatar-only"
              title={userData?.firstName}
              onClick={toggleProfileMenu}
              onError={(e) => (e.currentTarget.src = defaultProfileImg)}
            />
            {/* --- Exact Location: Profile Dropdown Menu Inside Header.js --- */}
{profileMenuOpen && (
  <div className="profile-dropdown-menu">
    {/* Profile Section */}
    <div className="dropdown-user-info">
      <span className="user-greet">Namaste,</span>
      <span className="user-name">{userData?.firstName || 'User'}</span>
    </div>
    
    <div className="dropdown-divider"></div>

    {/* Menu Items */}
    <Link to="/profile" className={`dropdown-item ${location.pathname === "/profile" ? "active" : ""}`}>
      <span className="item-icon">👤</span> Profile
    </Link>

    {/* NEW WALLET OPTION */}
    <Link to="/wallet" className={`dropdown-item ${location.pathname === "/wallet" ? "active" : ""}`}>
      <span className="item-icon">💰</span> Wallet
    </Link>

    <Link to="/my-sessions" className={`dropdown-item ${location.pathname === "/my-sessions" ? "active" : ""}`}>
  <span className="item-icon">📜</span> My Sessions
</Link>
    <Link to="/my-following" className={`dropdown-item ${location.pathname === "/my-following" ? "active" : ""}`}>
  <span className="item-icon">⭐</span> My Following
</Link>
  
    <Link to="/help-and-support" className={`dropdown-item ${location.pathname === "/help-and-support" ? "active" : ""}`}>
  <span className="item-icon">🎧</span> Help & Support
</Link>

    <div className="dropdown-divider"></div>

    <button onClick={handleLogout} className="dropdown-item logout-item">
      <span className="item-icon">⏻</span> Logout
    </button>
  </div>
)}
            {/* {profileMenuOpen && (
              <div className="profile-dropdown-menu">
                <Link to="/profile" className={location.pathname === "/profile" ? "active-dropdown-item" : ""}>Profile</Link>
                <button onClick={handleLogout}>Logout</button>
              </div>
            )} */}
          </div>
        // ) : (
        //   <Link to="/signup" className={getNavLinkClass("/signup") + " login-btn"}>
        //     Login
        //   </Link>
        // )}
        ) : (
          <div className="auth-single-wrapper">
  <button className="unified-auth-btn" onClick={() => openAuth('login')}>
    Login / Signup
  </button>
</div>
  // <div className="auth-buttons-header">
  //   <button className="login-nav-btn" onClick={() => openAuth('login')}>Login</button>
  //   <button className="signup-nav-btn" onClick={() => openAuth('signup')}>Sign Up</button>
  // </div>
)}
      </div>

      <div
        className={`hamburger ${menuOpen ? "open" : ""}`}
        onClick={toggleMenu}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      {/* <AuthModal isOpen={showAuthModal} onClose={() => setShowAuthModal(false)} mode={authMode} /> */}
    </header>
  );
};

export default Header;


